import { create } from "zustand";

export interface IEmailStore {
  emailId: string | null;           // Meridian email ID
  threadId: string | null;          // Meridian thread ID
  setEmailId: (value: string) => void;
  setThreadId: (value: string) => void;
}

const useEmailStore = create<IEmailStore>((set) => ({
  emailId: null,
  threadId: null,
  setEmailId: (value: string) => set({ emailId: value }),
  setThreadId: (value: string) => set({ threadId: value }),
}));

export default useEmailStore;
